<div class="modal-header">
    <h4 class="modal-title">{{ 'CSAT_PRIVACY' | translate }}</h4>
    <button type="button" class="close" (click)="dismissModal()">
        <span aria-hidden="true">&times;</span>
    </button>
</div>
<div class='privacy-modal'>
    <div class="modal-body">
        <h3 class="modal-header">
            {{ 'CSAT_PRIVACY_INTRODUCTION_HEADER' | translate }}
        </h3>
        <p class="mb-5">{{ "CSAT_PRIVACY_INTRODUCTION_CONTENT" | translate }}</p>

        <h3 class="modal-header">
            {{ 'CSAT_PRIVACY_WHICH_DATA_HEADER' | translate }}
        </h3>
        <p class="mb-5">{{ "CSAT_PRIVACY_WHICH_DATA_CONTENT" | translate }}</p>

        <h3 class="modal-header">
            {{ 'CSAT_PRIVACY_GATHER_DATA_HEADER' | translate }}
        </h3>
        <p class="mb-5">{{ "CSAT_PRIVACY_GATHER_DATA_CONTENT" | translate }}</p>

        <h3 class="modal-header">
            {{ 'CSAT_PRIVACY_PROCESS_DATA_HEADER' | translate }}
        </h3>
        <p class="mb-5">{{ "CSAT_PRIVACY_PROCESS_DATA_CONTENT" | translate }}</p>

        <h3 class="modal-header">
            {{ 'CSAT_PRIVACY_LEGAL_REASONS_HEADER' | translate }}
        </h3>
        <p class="mb-5">{{ "CSAT_PRIVACY_LEGAL_REASONS_CONTENT" | translate }}</p>

        <h3 class="modal-header">
            {{ 'CSAT_PRIVACY_SHARING_HEADER' | translate }}
        </h3>
        <p class="mb-5">{{ "CSAT_PRIVACY_SHARING_CONTENT" | translate }}</p>

        <h4 class="modal-header">
            {{ 'CSAT_PRIVACY_SHARING_PARTNERS_HEADER' | translate }}
        </h4>
        <p class="mb-3">{{ "CSAT_PRIVACY_SHARING_PARTNERS_CONTENT" | translate }}</p>
        <h4 class="modal-header">
            {{ 'CSAT_PRIVACY_SHARING_PUBLIC_GOVERNMENT_HEADER' | translate }}
        </h4>
        <p class="mb-3">{{ "CSAT_PRIVACY_SHARING_PUBLIC_GOVERNMENT_CONTENT" | translate }}</p>
        <h4 class="modal-header">
            {{ 'CSAT_PRIVACY_SHARING_DATA_PROCESSOR_HEADER' | translate }}
        </h4>
        <p class="mb-5">{{ "CSAT_PRIVACY_SHARING_DATA_PROCESSOR_CONTENT" | translate }}</p>

        <h3 class="modal-header">
            {{ 'CSAT_PRIVACY_RIGHTS_HEADER' | translate }}
        </h3>
        <p class="mb-5">{{ "CSAT_PRIVACY_RIGHTS_CONTENT" | translate }}</p>
        <h3 class="modal-header">
            {{ 'CSAT_PRIVACY_CONTACT_HEADER' | translate }}
        </h3>
        <p>{{ "CSAT_PRIVACY_CONTACT_CONTENT" | translate }}</p>
    </div>
</div>
<div class="modal-footer">
    <div class="right-container">
        <button type="button" id="secondary" class="btn btn-secondary" (click)="dismissModal()">
            {{ 'CANCEL' | translate }}
        </button>
    </div>
</div>
